import React, { useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";

import img1 from "../../assets/images/gallery/IMG-20251016-WA0000.jpg";
import img2 from "../../assets/images/gallery/IMG-20251016-WA0001.jpg";
import img3 from "../../assets/images/gallery/IMG-20251016-WA0002.jpg";
import img4 from "../../assets/images/gallery/IMG-20251016-WA0005.jpg";
import img5 from "../../assets/images/gallery/IMG-20251016-WA0006.jpg";
import img6 from "../../assets/images/gallery/IMG-20251016-WA0007.jpg";
import img7 from "../../assets/images/gallery/IMG-20251016-WA0008.jpg";
import img8 from "../../assets/images/gallery/IMG-20251016-WA0009.jpg";
import img9 from "../../assets/images/gallery/IMG-20251016-WA0010.jpg";
import img11 from "../../assets/images/gallery/IMG-20251016-WA0012.jpg";
import img12 from "../../assets/images/gallery/IMG-20251016-WA0014.jpg";
import img13 from "../../assets/images/gallery/IMG-20251016-WA0015.jpg";
import img14 from "../../assets/images/gallery/IMG-20251016-WA0016.jpg";
import img15 from "../../assets/images/gallery/IMG-20251016-WA0017.jpg";
import img16 from "../../assets/images/gallery/IMG-20251016-WA0018.jpg";
import img17 from "../../assets/images/gallery/IMG-20251016-WA0019.jpg";
import img1NEW from "../../assets/images/gallery/gallery-1.JPG";
import img2NEW from "../../assets/images/gallery/gallery-2.JPG";
import img3NEW from "../../assets/images/gallery/gallery-3.JPG";
import img4NEW from "../../assets/images/gallery/gallery-4.JPG";
import img5NEW from "../../assets/images/gallery/gallery-5.JPG";
import img6NEW from "../../assets/images/gallery/gallery-6.JPG";
import img7NEW from "../../assets/images/gallery/gallery-7.JPG";
import img8NEW from "../../assets/images/gallery/gallery-8.JPG";
import img9NEW from "../../assets/images/gallery/gallery-9.JPG";
import img10NEW from "../../assets/images/gallery/gallery-10.JPG";
import img11NEW from "../../assets/images/gallery/gallery-11.JPG";
import img12NEW from "../../assets/images/gallery/gallery-12.JPG";
import img13NEW from "../../assets/images/gallery/gallery-13.JPG";
import img14NEW from "../../assets/images/gallery/gallery-14.JPG";
import img15NEW from "../../assets/images/gallery/gallery-15.JPG";
import img16NEW from "../../assets/images/gallery/gallery-16.JPG";
import img17NEW from "../../assets/images/gallery/gallery-17.JPG";
import img18NEW from "../../assets/images/gallery/gallery-18.JPG";
import img19NEW from "../../assets/images/gallery/gallery-19.JPG";
import { Link } from "react-router-dom";

const images = [
    img1NEW, img2NEW, img3NEW, img4NEW, img5NEW, img6NEW, img7NEW, img8NEW, img9NEW,
    img10NEW, img11NEW, img12NEW, img13NEW, img14NEW, img15NEW, img16NEW, img17NEW,
    img18NEW, img19NEW,
    img4, img5, img7, img8, img9, img1, img2, img3,
    img11, img12, img13, img14, img15, img16, img17, img6
];

const Gallery = () => {
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    useEffect(() => {
        document.title = "Gallery | Gujarat State Allied and Healthcare Council";
        window.scrollTo(0, 0);
    }, []);

    const openLightboxOnSlide = (index) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: index + 1,
        });
    };

    return (
        <>
            <div className="gallery-top-title wrappermain">
                <div
                    className="banner-image wrappermain"
                    style={{
                        backgroundImage: "url(" + Background_Member2 + ")",
                        backgroundSize: "fill",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        padding: "25px 0",
                    }}
                >
                    <div className="banner-inner-breadcrumb">
                        <div className="container">
                            <nav aria-label="breadcrumb">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={"/"}>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Gallery</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <h3 className="text-center text-uppercase m-0 gallary-title">gallery</h3>
            </div>

            <section className="section">
                <div className="container gallary gallary-main">
                    <div className="row">
                        {images && images.map((img, index) => (
                            <div
                                className="col-xl-3 col-lg-3 col-md-4 col-12 col-sm-6 mt-3"
                                key={index}
                            >
                                <img
                                    src={img}
                                    alt={`Gallery ${index}`}
                                    onClick={() => openLightboxOnSlide(index)}
                                    style={{ cursor: "pointer", height: '200px', width: '100%', objectFit: 'cover' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <FsLightbox
                toggler={lightboxController.toggler}
                sources={images}
                slide={lightboxController.slide}
            />
        </>
    );
};

export default Gallery;
